import Vue from 'vue';
import { WebAuth } from 'auth0-js';
// const CLIENT_ID = '{AUTH0_CLIENT_ID}';
// const CLIENT_DOMAIN = '{AUTH0_DOMAIN}';
// const REDIRECT = 'YOUR_CALLBACK_URL';
// const SCOPE = '{SCOPE}';
// const AUDIENCE = 'AUDIENCE_ATTRIBUTE';
const AUTH0_DOMAIN = 'abmi.auth0.com';
const AUTH0_CLIENT_ID = 'Eg2MPVtqkf3SuKS5uXzP97nxU13Z2K1i';
// const CLIENT_DOMAIN = 'abmi.auth0.com';
/* callback url needs to be register in auth0 allowed call back fields */
const AUTH0_CALLBACK_URL = window.location.origin; // window.location.href; //'http://localhost:8088/';
const AUDIENCE = 'http://www.wildtrax.ca';
const ID_TOKEN_KEY = 'id_token';
const ACCESS_TOKEN_KEY = 'access_token';
const EXPIRE_TOKEN_KEY = 'expire_at';
const ORIGINAL_PATH = 'originalLocalPath';
let gAuthenticated;
const authParam = {
  domain: AUTH0_DOMAIN,
  clientID: AUTH0_CLIENT_ID,
  redirectUri: AUTH0_CALLBACK_URL,
  // audience: 'https://' + AUTH0_DOMAIN + '/userinfo',
  audience: AUDIENCE,
  responseType: 'token id_token',
  scope: 'openid email profile',
  leeway: 60
};

let auth = new WebAuth(authParam);
export const EventBus = new Vue();
/* this call back , need to be at created section, otherwise, the popup window won't close */
// auth.popup.callback({});

function setSession (authResult, bRefreshPage, redirectPath) {
  // console.log('reload page');
  if (authResult) {
    //  window.location.hash = '';
    const expiresAt = JSON.stringify(
      authResult.expiresIn * 1000 + new Date().getTime()
    );
    localStorage.setItem(ACCESS_TOKEN_KEY, authResult.accessToken);
    localStorage.setItem(ID_TOKEN_KEY, authResult.idToken);
    localStorage.setItem(EXPIRE_TOKEN_KEY, expiresAt);
    console.log('newly logged in will expire at ', new Date(Number(expiresAt)));
    // EventBus.$emit('authentication_updated', gAuthenticated);
    // EventBus.$emit('token_updated', authResult.accessToken);
    // getProfile();
    if (redirectPath) {
      window.location.href = redirectPath;
    } else if (bRefreshPage) {
      console.log('reloading');
      window.location.reload(true);
    } else {
      gAuthenticated = isLoggedIn();
      scheduleRenewal();
    }
  }
}
/* From the webAuth.authorize depending on the user intentions you would pass a conditional parameter:
webAuth.authorize({ mode: "[login|signUp]", ... });
On the hosted login page you would configure Lock with:

var lock = new Auth0Lock(config.clientID, config.auth0Domain, {
    initialScreen: config.extraParams.mode,
    ...
});
*/
function savePath () {
  localStorage.setItem(ORIGINAL_PATH, window.location.href);
}
export function signup () {
  savePath();
  auth.authorize({
    mode: 'signUp',
    responseType: 'token id_token',
    redirectUri: AUTH0_CALLBACK_URL,
    state: ORIGINAL_PATH
  });
}
export function login () {
  savePath();
  auth.authorize({
    responseType: 'token id_token',
    redirectUri: AUTH0_CALLBACK_URL,
    state: ORIGINAL_PATH
  });
}
/*
  auth.popup.authorize({},
    // auth.authorize({},
    function (err, authResult) {
      console.log(' haha ha ' + err);
      if (err) {
        console.error(err);
      }
      setSession(authResult, true);
    });  */
export function logout () {
  localStorage.removeItem(ID_TOKEN_KEY);
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(EXPIRE_TOKEN_KEY);
  gAuthenticated = false;
  // console.debug(' logout bus');
  EventBus.$emit('authentication_updated', gAuthenticated);
  getProfile();
  clearTimeout(tokenRenewalTimeout);
  window.location.href = '/home.html';
}
// function requireAuth (to, from, next) {
//   if (!isLoggedIn()) {
//     next({
//       path: '/',
//       query: { redirect: to.fullPath }
//     });
//   } else {
//     next();
//   }
// }

function getIdToken () {
  return localStorage.getItem(ID_TOKEN_KEY);
}

// function getAccessToken () {
//   return localStorage.getItem(ACCESS_TOKEN_KEY);
// }
// Helper function that will allow us to extract the access_token and id_token
// function getParameterByName (name) {
//   let match = RegExp('[#&]' + name + '=([^&]*)').exec(window.location.hash);
//   return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
// }

export function isLoggedIn () {
  const idToken = getIdToken();
  const isLoggedIn = !!idToken && !isTokenExpired();

  EventBus.$emit('authentication_updated', isLoggedIn);
  // getProfile ();
  return isLoggedIn;
}

export function isTokenExpired () {
  const expiresAt = JSON.parse(localStorage.getItem(EXPIRE_TOKEN_KEY));
  console.log('token expires ', new Date().getTime() > Number(expiresAt), new Date(Number(expiresAt)));
  return new Date().getTime() > Number(expiresAt);
}

export function getProfile () {
  const accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);
  if (accessToken) {
    auth.client.userInfo(accessToken, function (err, profile) {
      if (err && !profile) {
        EventBus.$emit('profile_updated', {given_name: 'Guest'});
      } else {
        EventBus.$emit('profile_updated', profile);
      }
    });
  } else {
    EventBus.$emit('profile_updated', {given_name: 'Guest'});
  }
}

function renewToken () {
  console.debug(new Date().toUTCString() + ' renewing token');
  auth.checkSession({},
    function (err, authResult) {
      if (err) {
        console.error(new Date().toUTCString() + ' renewing token failed: ');
        console.error(err);
      }
      setSession(authResult, false, null);
    }
  );
}

let tokenRenewalTimeout;
// ...
function scheduleRenewal () {
  const expiresAt = JSON.parse(localStorage.getItem(EXPIRE_TOKEN_KEY));
  const delay = expiresAt - Date.now();
  console.debug(new Date().toUTCString() + ' will be valid for ' + delay + 'ms');
  if (delay > 10000) { // schedule to renew 10 seconds before section expires.
    tokenRenewalTimeout = setTimeout(function () {
      renewToken();
    }, delay - 10000);
  } else if (delay > 0) { // if within little time, renewed directly.
    renewToken();
  }
}

function handleAuthentication () {
  auth.parseHash(function (err, authResult) {
    // console.debug(new Date().toUTCString() + ' log in error = ' + err);
    if (err && err.error) {
      // remove query parameters, so when page refreshed, same error won't be alerted again.
      // window.history.pushState({}, "Wildtrax Home", '/home.html');
      // alert won't stay (disappeared) if show alert too earlier, so use a timer to delay it.
      window.setTimeout(() => {
        alert('You login has failed: ' + err.errorDescription);
      }, 2000);
      return;
    } else if (authResult && authResult.accessToken && authResult.idToken) {
      // window.location.hash = '';
      const redirectPath = localStorage.getItem(ORIGINAL_PATH);
      localStorage.removeItem(ORIGINAL_PATH);
      setSession(authResult, true, redirectPath);
      return;
    }
    scheduleRenewal();
  });
}
document.addEventListener('DOMContentLoaded',
// window.addEventListener('load',
  function () {
  // console.log('loading page',  document.readyState, document.readyState)
    handleAuthentication();
  });

// renewal works for password and user name
// for social providers: please set up the API key: https://auth0.com/docs/identityproviders
